import { render, staticRenderFns } from "./commission-record-container.vue?vue&type=template&id=1cdcf810"
import script from "./commission-record-container.vue?vue&type=script&lang=ts"
export * from "./commission-record-container.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports